import React, { useState } from "react";

import "./Contact.css";
import logo from '../../assets/logo_white.png'
const Contact = () => {
    const [formData, setFormData] = useState({ name: '', email: '', message: '' });
    const { username, email, message } = formData;

    const handleChangeInput = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value })
    };
    const baseUrl = "http://localhost:8000";
    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = {
            name: formData.username,
            email: formData.email,
            message: formData.message,
        };

        const res = await fetch(`${baseUrl}/email/sendEmail`, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                Accept: "applications/json",
                "Content-Type": "application/json",
            },
        }).then((res) => {
            console.log(res);
            if (res.status > 199 && res.status < 300) {
                alert("Sent successfully!");
            }
        });
        alert('Sent successfully')
    };
    return (
      <div className='contact__container ' id='contact'>
        <div className='contact__container-1'>
          <div className='headtext__cormorant' style={{ fontSize: 40 }}>
            Get in touch
          </div>
          <div className='p__opensans'>
            <span style={{ display: "inline", color: "#106690" }}>
              Contact with our team
            </span>{" "}
            to talk about how we can help your business process at scale, or
            sign up for more info.
          </div>
          <div className='contact__info'>
            <div className='contact__info-1'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                fill='currentColor'
                class='bi bi-geo-alt-fill'
                viewBox='0 0 16 16'
                style={{ marginRight: 10 }}
              >
                <path d='M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z' />
              </svg>
              <p>
                1-4929, Lane No. 6, Balbirnagar Ext.,
                <br /> Shahdara, Delhi 110032
              </p>
            </div>
            <div className='contact__info-2'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                fill='currentColor'
                class='bi bi-telephone-fill'
                viewBox='0 0 16 16'
                style={{ marginRight: 10 }}
              >
                <path
                  fill-rule='evenodd'
                  d='M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z'
                />
              </svg>
              <p>+91-8888888888</p>
            </div>
            <div className='contact__info-3'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                fill='currentColor'
                class='bi bi-envelope-fill'
                viewBox='0 0 16 16'
                style={{ marginRight: 10 }}
              >
                <path d='M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697ZM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757Zm3.436-.586L16 11.801V4.697l-5.803 3.546Z' />
              </svg>
              <p>info@unyn.com</p>
            </div>
          </div>
        </div>
        <div className='contact__container-2'>
          <h1 className='headtext__cormorant' style={{ fontSize: 30 }}>
            Say something
          </h1>
          <form className='contact__form' onSubmit={handleSubmit}>
            <input
              type='text'
              placeholder='Your Name...'
              value={username}
              name='username'
              className='form__input'
              onChange={handleChangeInput}
              required
            />
            <input
              type='email'
              placeholder='Your Mail...'
              value={email}
              name='email'
              className='form__input'
              onChange={handleChangeInput}
              required
            />
            <textarea
              placeholder='Message...'
              value={message}
              name='message'
              className='form__textarea'
              onChange={handleChangeInput}
              required
            />
            <button className='form__button' type='submit'>
              Send
            </button>
          </form>
        </div>
        <div className='contact__container-3 section__padding'>
          <div className='contact__subcontainer-1'>
            <div className='subscribe'>
              <img src={logo} />
              <p className='p__opensans'>
                Stay up to date on the latest features and releases by joining
                our newsletter.
              </p>
              <div className='whitePlaceholder'>
                <input type='email' placeholder='Enter your email' />
                <button className='custom__button1'>Subscribe</button>
              </div>
              <p className='p__opensans' style={{ fontSize: 12 }}>
                {" "}
                By subscribing, you agree to our Privacy Policy and consent to
                receive updates from our company.
              </p>
            </div>
            <div className='links'>
              <ul className='p__opensans'>
                Quick Links
                <li>
                  <a href='#home'>Home</a>
                </li>
                <li>
                  <a href='#about'>About us</a>
                </li>
                <li>
                  <a href='#services'>Services</a>
                </li>
                <li>
                  <a href='#events'>Events</a>
                </li>
              </ul>
            </div>
            <div className='updates'>
              <ul className='p__opensans'>
                Updates
                <li>
                  <a href='#news'>News</a>
                </li>
                <li>
                  <a href='#blog'>Blog</a>
                </li>
                <li>
                  <a href='#faq'>FAQ's</a>
                </li>
                <li>
                  <a href='#contact'>Contact us</a>
                </li>
              </ul>
            </div>
            <div className='follow p__opensans' style={{ color: "white" }}>
              Follow us
              <div>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='16'
                  height='16'
                  fill='white'
                  class='bi bi-twitter'
                  viewBox='0 0 16 16'
                >
                  <path d='M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15z' />
                </svg>
                <p>Twitter</p>
              </div>
              <div>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='16'
                  height='16'
                  fill='white'
                  class='bi bi-facebook'
                  viewBox='0 0 16 16'
                >
                  <path d='M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z' />
                </svg>
                <p>Facebook</p>
              </div>
              <div>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='16'
                  height='16'
                  fill='white'
                  class='bi bi-instagram'
                  viewBox='0 0 16 16'
                >
                  <path d='M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z' />
                </svg>
                <p>Instagram</p>
              </div>
            </div>
          </div>
          <div className='divider'></div>
          <div className='copyright'>
            <p>© 2023 UNYN. All rights reserved.</p>
            <p>Privacy Policy</p>
            <p>Term of Service</p>
            <p>Design and Developed by InGelt Pvt. Ltd.</p>
          </div>
        </div>
      </div>
    );
};

export default Contact;
